'use client'
import React, { useState, useEffect, useCallback } from 'react';
import { generateQuestions } from './actions';
import { useKindeBrowserClient } from "@kinde-oss/kinde-auth-nextjs";
import { useRouter } from "next/navigation";
import JobDescriptionSection from './jobDescriptionSection';
import GeneratedQuestionsSection from './generatedQuestionsSection';
import Link from 'next/link';
import LoginRedirect from '@/components/LoginRedirect';
import AdSterraIFrameBannerAuto from '@/components/adsterra-ui/adsterra-ifram-auto';
import AdSterra320x50 from '@/components/adsterra-ui/adsterra_320x50';
import AdSterraNativeBanner from '@/components/adsterra-ui/adsterra-native-banner';

export type Question = {
  question: string;
  why: string;
  tip: string;
};

function QuestionsGeneratorWrapper() {
  const [jd, setJd] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<{ technical: Question[], behavioral: Question[] } | null>(null);
  const [userId, setUserId] = useState<string>('');
  const [copySuccess, setCopySuccess] = useState(false);
  const { user, isLoading, isAuthenticated } = useKindeBrowserClient();
  const router = useRouter();

  const handleGenerate = async () => {
    setLoading(true);
    // Simulate API Call
    if (!jd) return;
    setLoading(true);
    
    try {
      const aiResults = await generateQuestions(jd, "userId"); // Calling the Server Action

      // force user tokens balance component to refresh
		  window.dispatchEvent(new Event('tokens-deducted'));
      
      setResults(aiResults!);
    } catch (error) {
      console.error("AI Generation failed:", error);
      alert("Something went wrong with the AI.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = useCallback(() => {
    if (results) {
      let techQuestions = "Technical Questions: " + '\n';
      
      results.technical.forEach((q, i) => {
        let qString = "";
        
        qString = `Question ${i+1}: ` + q.question + '\n'
          + "Why? " + q.why + '\n';
          + "Tip: " + q.tip + '\n';

        techQuestions += qString + '\n';
      });

      let behvQuestions = "Behavioral Questions: " + '\n';
      
      results.behavioral.forEach((q, i) => {
        let qString = "";
        
        qString = `Question ${i}: ` + q.question + '\n'
          + "Why? " + q.why + '\n';
          + "Tip: " + q.tip + '\n' + '\n';

        behvQuestions += qString + '\n';
      });

      const questions = techQuestions + '\n' + behvQuestions;
       
      navigator.clipboard.writeText(questions).then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000); // Reset success message after 2s
      });
    }
  }, [ results ]);

  return (
    <>
        <div className="space-y-8 max-w-7xl mx-auto">
        <div className='text-sm md:text-lg'>
            <Link className='underline' href={"/"}>Home</Link>
            <span className='pl-2 pr-2'>{">"}</span>
            <Link className='underline' href={"/dashboard"}>Dashbord</Link>
            <span className='pl-2 pr-2'>{"> Interview Questions Predictor"}</span>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100">
            Interview Questions Predictor
        </h1>

        <AdSterraIFrameBannerAuto position='top' />

        <p className="text-gray-600 dark:text-gray-400">
            Input the Job Description of the job you are intreviewed for and let's predict some interview questions for you.
        </p>
        
        <div className='flex flex-col space-y-4'>
            <div className="grid grids-rows gap-4">
            <JobDescriptionSection 
                loading={loading} jd={jd} 
                setJd={setJd} handleGenerate={handleGenerate} />

            <hr />
            
            <AdSterra320x50 />

            <hr />

            {/* Right Side: Results */}
            <GeneratedQuestionsSection 
                copySuccess={copySuccess} results={results} userId={userId} 
                handleCopy={handleCopy} />
            
            </div>
        </div>
        </div>

        <div className='w-full flex justify-center items-center mt-8'>
          <AdSterraNativeBanner />
        </div>

        {/* 2. THE OVERLAY (Only shows if not logged in) */}
        {(!isAuthenticated && !isLoading) && (
        <LoginRedirect message="to analyze this job description" />
        )}
    </>
  );
}

export default QuestionsGeneratorWrapper